module.exports = __webpack_public_path__ + "images/icons_v2/collapse-0127339b.svg";